// src/utils/gerarPlano30Dias.js
import sugestoesICV from './sugestoesICV';

const NOMES_FATORES = {
  DGV: 'Disposição Geral para Vendas',
  R: 'Receptividade',
  A: 'Agressividade',
  I: 'Compreensão',
  II: 'Adaptabilidade',
  III: 'Autocontrole',
  IV: 'Tolerância à Frustração',
  V: 'Combatividade',
  VI: 'Domínio',
  VII: 'Segurança',
  VIII: 'Atividade',
  IX: 'Sociabilidade',
};

export const classificarPT = (pt) => {
  if (pt < 2) return 'muito_baixo';
  if (pt <= 4) return 'baixo';
  if (pt <= 6) return 'medio';
  if (pt <= 8) return 'acima_media';
  return 'alto';
};

// quantas ações por fator, conforme nível
const QUANTIDADE_POR_FAIXA = {
  muito_baixo: 2,
  baixo: 2,
  medio: 2,
  acima_media: 1,
  alto: 1,
};

// pega as melhores sugestões disponíveis para o fator/faixa
function escolherSugestoes(fator, faixa, qtd) {
  const pack = sugestoesICV[fator] || {};
  // acima_media cai para 'medio' se não houver pack próprio
  let base = pack[faixa] || (faixa === 'acima_media' ? pack.medio : []);
  const out = [];
  if (Array.isArray(base)) out.push(...base.slice(0, qtd));

  // fallback se veio pouco: puxa 'baixo' e depois 'medio'
  if (out.length < qtd && Array.isArray(pack.baixo)) {
    pack.baixo.forEach(s => { if (out.length < qtd) out.push(s); });
  }
  if (out.length < qtd && Array.isArray(pack.medio)) {
    pack.medio.forEach(s => { if (out.length < qtd) out.push(s); });
  }
  return out.map(s => ({ ...s, fator, nomeFator: NOMES_FATORES[fator] || fator }));
}

// distribuição simples: round-robin em 4 semanas
function distribuirEm4Semanas(acoes) {
  const semanas = [[], [], [], []];
  acoes.forEach((a, i) => semanas[i % 4].push(a));
  return semanas.map((tarefas, idx) => ({
    semana: idx + 1,
    tarefas,
  }));
}

// ---------- API PRINCIPAL ----------
export function gerarPlano30Dias(ptResultados) {
  // 1) ordena fatores por PT crescente (foco em gaps)
  const fatoresOrdenados = Object.keys(ptResultados || {}).sort(
    (a, b) => (ptResultados[a] ?? 0) - (ptResultados[b] ?? 0)
  );

  // 2) monta lista de ações (pega 1-2 por fator conforme faixa)
  const acoes = [];
  const foco = [];
  fatoresOrdenados.forEach((fator) => {
    const pt = ptResultados[fator] ?? null;
    if (pt == null) return;
    const faixa = classificarPT(pt);
    foco.push({ fator, nomeFator: NOMES_FATORES[fator] || fator, pt, faixa });

    const qtd = QUANTIDADE_POR_FAIXA[faixa] || 1;
    const blocos = escolherSugestoes(fator, faixa, qtd);
    // anexa metadados úteis
    blocos.forEach(b => acoes.push({
      fator,
      nomeFator: NOMES_FATORES[fator] || fator,
      faixa,
      pt,
      ...b,
    }));
  });

  // 3) distribui em 4 semanas (30 dias ~ 4 semanas)
  const semanas = distribuirEm4Semanas(acoes);

  return { resumo: foco, semanas };
}

export { NOMES_FATORES }; // útil em telas
